import { Link } from "react-router-dom"
import { Menu } from 'antd'

/**
 * 点击顶部导航时，左边导航会对应加上高亮
 */
type Props = {
  topNavData: Object[],
  topIndex: string

  handleTopNavClick: ({ key }: { key: any }) => void
}

export default function TopMenu(props: Props) {

  let TopNavElement = props.topNavData.map((el: any, index: number) => <Menu.Item key={index} onClick={props.handleTopNavClick} ><Link to={el.route_url}>{el.name}</Link></Menu.Item>)

  return (<Menu className="clear" theme="light" mode="horizontal" selectedKeys={[`${props.topIndex}`]}>
    {TopNavElement}
  </Menu>)
}